; (function (root, factory) {
    // UMD/AMDWeb module bolierplate: https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('ImageUploader', ['jQuery'], factory);
    } else {
        // Browser globals
        root.ImageUploader = factory(jQuery);
    }
}(typeof self !== 'undefined' ? self : this, function ($) {
    'use strict';

    function cleanLog() {
        $('ul', this.$log).empty();
        this.count = 0;
        this.errorCount = 0;
        this.$successCount.text(this.count);
        this.$errorCount.text(this.errorCount)
    }

    function updateProgress(index, count) {
        if (!this.progress) {
            return;
        }

        var value = '0%';
        index = parseInt(index);

        if (!isNaN(index)) {
            value = ((index + 1) / count * 100).toFixed(0) + '%';
        }

        if (this.progressValue) {
            this.progressValue.innerText = value;
        }

        if (this.thumb.style) {
            this.thumb.style.width = value;
        }
    }

    function getData(file, index) {
        var data = new FormData();

        Array.prototype.forEach.apply(this.otherInputs, [function (el) {
            data.append(el.name, el.value);
        }]);

        data.append('fileIndex', index);
        data.append('fileData', file);
        data.append('fileName', file.name);

        return data;
    }

    function shouldValidateImages() {
        if (!isNaN(parseInt(this.config.maxWidth))) return true;
        if (!isNaN(parseInt(this.config.maxHeight))) return true;
        if (!isNaN(parseInt(this.config.minWidth))) return true;
        if (!isNaN(parseInt(this.config.minHeight))) return true;
        return false;
    }

    function shouldValidateFileSize() {
        return !isNaN(parseInt(this.config.maxFileSize));
    }

    function validateFileSize(config, file, index) {
        var validationItem = { index: index, isValid: true, size: 0, width: 0, height: 0, message: '', size: file.size };
        validationItem.size = file.size;

        if (file.size > config.maxFileSize) {
            //invalid size
            var message = file.name + 'is ' + file.size + ' bytes long and it exceeds the max allowed size ' + config.maxFileSize + '.';

            if (typeof(config.onValidationError) === 'function') {
                config.onValidationError({
                    success: false,
                    message: message
                });
            }
            validationItem.isValid = false;
            validationItem.message = message;
        }

        return validationItem;
    }


    function ImageUploader(element) {
        this.container = element;
        this.$form = $(this.container);

        if (!this.container || !this.$form.is('form')) {
            throw new Error('Element passed to ImageUploader component does not exist or is not a form.');
        }

        if (!this.$form.is('[enctype="multipart/form-data"]')) {
            throw new Error('Please add enctype="multipart/form-data" to your form as ImageUploader only relies "multipart/form-data" forms to work.');
        }

        this.url = this.container.getAttribute('action');

        this.input = this.container.querySelector('input[type="file"][multiple]');
        this.$inputFile = $(this.input);

        if (!this.input) {
            throw new Error('Please make sure that your form contains one input of type="file" with the "multiple" attribute.');
        }

        this.config = {};

        this.otherInputs = this.container.querySelectorAll('input:not([type="file"]):not([type="submit"]), select, textarea')
        this.button = this.container.querySelector('button[type="submit"]');
        this.log = this.container.querySelector('[data-upload-log]');
        this.preview = this.container.querySelector('[data-image-preview]');
        this.progress = this.container.querySelector('[data-progress]');

        if (this.progress) {
            this.thumb = this.progress.querySelector('[data-progress-bar]');
            this.progressValue = this.progress.querySelector('[data-progress-value]');
            updateProgress.apply(this, [null]);
        }

        this.$submit = $(this.button);
        this.$log = $(this.log);
        this.$preview = $(this.preview);
        this.$imageList = $('ul', this.$preview);
        this.$successCount = $(this.container).find('[data-count="success"]');
        this.$errorCount = $(this.container).find('[data-count="error"]');

        this.filesValidations = [];

        cleanLog.apply(this);

        this.init = this.init.bind(this);
        this.onchange = this.onchange.bind(this);
        this.onerror = this.onerror.bind(this);
        this.onsuccess = this.onsuccess.bind(this);
        this.upload = this.upload.bind(this);

        if (this.$inputFile) {
            this.$inputFile.on('change', $.proxy(this.onchange, this));
        }

        if (this.$submit) {
            this.$submit.on('click', $.proxy(this.upload, this));
        }


        this.init();
    };

    ImageUploader.prototype = {
        init: function (options) {
            var defaults = {
                cssPrefix: 'img-upl',
                minWidth: null,
                maxWidth: null,
                minHeight: null,
                maxHeight: null,
                maxFileSize: parseInt(this.input.getAttribute('data-val-maxfilesize-limit')),
                maxFileSizeErrorMessage: this.input.getAttribute('data-val-maxfilesize')
                    ? this.input.getAttribute('data-val-maxfilesize')
                    : 'Image %f exceeds maximum file size limit of %l bytes',
                onValidate: null,
                onImagesLoading: null,
                onImagesLoaded: null,
                onStart: null,
                onProgress: null,
                onFinish: null
            };

            $.extend(this.config, defaults, options);
        },
        disable: function () {
            window.onbeforeunload = function () { return false; }

            this.input.disabled = true;

            Array.prototype.forEach.apply(this.otherInputs, [function (el) {
                el.disabled = true;
            }]);

            this.container.classList.add('-loading');
        },
        enable: function () {
            window.onbeforeunload = null;

            this.input.disabled = false;
            Array.prototype.forEach.apply(this.otherInputs, [function (el) {
                el.disabled = false;
            }]);

            this.container.classList.remove('-loading');
        },
        onerror: function (message) {
            this.$log.find('ul').append($('<li class="error">' + message + '</li>'));
            this.$log.removeClass('-hidden');
            this.errorCount++;
            this.$errorCount.text(this.errorCount)
        },
        onsuccess: function (message) {
            this.count++;
            this.$successCount.text(this.count);
        },
        onchange: function (e) {
            e.preventDefault();
            var self = this;

            cleanLog.apply(this);
            this.container.classList.remove('-loaded');
            this.container.classList.remove('-has-images');
            this.$submit.attr('disabled', false);

            this.$imageList.empty();

            this.$log.addClass('-hidden');

            function loadImage() {
                reader.readAsDataURL(self.input.files[current]);
            }

            if (this.input.files && this.input.files.length > 0) {

                this.container.classList.add('-has-images');

                if (typeof(this.config.onImagesLoading) === 'function') {
                    this.config.onImagesLoading();
                }

                var current = 0;
                var reader = new FileReader();

                reader.onload = function (e) {
                    var file = self.input.files[current];

                    var image = new Image();
                    image.src = e.target.result;
                    image.id = 'image-' + current;
                    image.className = 'image';

                    image.onload = function () {

                        if (shouldValidateImages.apply(self)) {

                            var validationItem = self.filesValidations[current];

                            validationItem.width = image.naturalWidth;
                            validationItem.height = image.naturalHeight;

                            if (!(image.naturalWidth >= self.config.minWidth &&
                                image.naturalWidth <= self.config.maxWidth &&
                                image.naturalHeight >= self.config.minHeight &&
                                image.naturalHeight <= self.config.maxHeight)) {

                                var message = file.name + ' is ' + image.naturalWidth + 'x' + image.naturalHeight + ' but width and height must be fall in the range [' + self.config.minWidth + 'x' + self.config.maxWidth + '] and [' + self.config.minHeight + 'x' + self.config.maxHeight + '].';
                                //invalid width or height
                                if (self.config.onValidationError) {
                                    self.config.onValidationError({
                                        success: false,
                                        message: message,
                                    });
                                }
                                validationItem.message += message;
                                validationItem.isValid = false;
                            }

                            image.dataset['image_width'] = validationItem.width;
                            image.dataset['image_height'] = validationItem.height;
                            image.dataset['image_size'] = validationItem.size;
                            image.dataset['is_valid'] = validationItem.isValid;
                            image.dataset['val_message'] = validationItem.message;

                            if (!validationItem.isValid) {
                                image.classList.add('-error');
                            }
                        }

                        var $listItem = $('<li class="' + self.config.cssPrefix + '-image-container-' + current + '" />').append(image);
                        self.$imageList.append($listItem);

                        if (current < self.input.files.length - 1) {
                            current++;
                            setTimeout(loadImage, 5);
                        } else {
                            if (typeof(self.config.onImagesLoaded) === 'function') {
                                self.config.onImagesLoaded();
                            }
                            self.$submit.attr('disabled', false);
                        }
                    };
                };

                loadImage();
            }
        },
        upload: function (e) {
            e.preventDefault();
            var self = this;

            if (!this.input.files.length) {
                return;
            }

            var valid = true;

            if (typeof (this.$form.validate) === 'function') {
                valid = this.$form.validate().form();
            }

            if (valid) {
                this.disable();
                this.$submit.attr('disabled', true);

                var current = 0;

                function uploadImage() {

                    function next() {
                        //next file
                        if (current < self.input.files.length - 1) {
                            updateProgress.apply(self, [current, self.input.files.length]);
                            if (typeof (self.config.onProgress) === 'function') {
                                self.config.onProgress(current, self.input.files.length);
                            }
                            current++;
                            setTimeout(uploadImage, 5);
                        } else {
                            //finish    
                            self.enable();
                            updateProgress.apply(self, [self.input.files.length, self.input.files.length]);

                            if (typeof (self.config.onFinish) === 'function') {
                                self.config.onFinish(self.input.files.length, self.input.files, length);
                            }
                        }
                    }

                    if (shouldValidateImages.apply(self) && !self.filesValidations[current].isValid) {
                        //next file           
                        next();
                        return;
                    }


                    var $imageContainer = $('.' + self.config.cssPrefix + '-image-container-' + current);

                    if (shouldValidateFileSize.apply(self)) {
                        var isValid = self.input.files[current].size < self.config.maxFileSize;

                        if (!isValid) {
                            self.onerror(self.config.maxFileSizeErrorMessage
                                .replace('%f', self.input.files[current].name)
                                .replace('%l', self.config.maxFileSize)
                            );
                            $imageContainer.addClass('-error');
                            self.$form.addClass('-loaded');
                            next();
                            return;
                        }
                    }

                    var request = new XMLHttpRequest();
                    request.open('POST', self.url, true);
                    request.onload = function (e) {

                        var response = JSON.parse(e.target.response);

                        if (response.Success) {
                            self.onsuccess(response.Message);
                            $imageContainer.addClass('-success');
                        }
                        else {
                            self.onerror(response.Message);
                            $imageContainer.addClass('-error');
                        }
                        self.$form.addClass('-loaded');

                        next();
                    };

                    request.onerror = function () {

                    }

                    request.send(getData.apply(self, [self.input.files[current], current]));

                }

                if (typeof(self.config.onStart) === 'function') {
                    self.config.onStart(self.input.files.length);
                }

                uploadImage();
            }
        }
    };

    return ImageUploader;
}));